/**
 * Model for contain the tell us about yourself data on the main signup page.
 */
export class OnboardingTellUsAboutYourself {

  email: string;
  phoneNumber: string;
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  preferredName: string;
  addressType: number | undefined;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  stateId: number | undefined;
  zipcode: string;
  birthDate: Date | undefined;
  ssnNumber: string;
  isUSCitizen: boolean | null;
  citizenship: string;

  /**
   * Constructor
   */
  constructor() {
    this.email = "";
    this.phoneNumber = "";
    this.firstName = "";
    this.middleName = "";
    this.lastName = "";
    this.suffix = "";
    this.preferredName = "";
    this.addressType = undefined;
    this.addressLine1 = "";
    this.addressLine2 = "";
    this.city = "";
    this.state = "";
    this.stateId = 0;
    this.zipcode = "";
    this.birthDate = undefined;
    this.ssnNumber = "";
    this.isUSCitizen = null;
    this.citizenship = "";
  }
}
